import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

interface StatementData {
  date: string;
  voucher: string;
  narration: string;
  debit: string;
  credit: string;
  balance: string;
}

interface StatementTableProps {
  data: StatementData[];
  title?: string;
}

const StatementTable: React.FC<StatementTableProps> = ({ data, title = 'Statement Table' }) => (
  <Card sx={{ mb: 3 }}>
    <CardContent>
      <Typography variant="h6" sx={{ mb: 2 }}>{title}</Typography>
      <TableContainer component={Paper} id="statement-table">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Txn Date</TableCell>
              <TableCell>Reference</TableCell>
              <TableCell>Narration</TableCell>
              <TableCell>Debit</TableCell>
              <TableCell>Credit</TableCell>
              <TableCell>Balance</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((txn, idx) => (
              <TableRow key={idx}>
                <TableCell>{txn.date}</TableCell>
                <TableCell>{txn.voucher}</TableCell>
                <TableCell>{txn.narration}</TableCell>
                <TableCell>{txn.debit}</TableCell>
                <TableCell>{txn.credit}</TableCell>
                <TableCell>{txn.balance}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CardContent>
  </Card>
);

export default StatementTable; 